import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Delete } from '@mui/icons-material'

type ActionsMenuProps = {
    anchorEl?: null | HTMLElement
    id?: string
    onClose: () => void
    onDeleteAction: (id: string) => void
}

export const ActionsMenu: React.FC<ActionsMenuProps> = ({ anchorEl, onClose, id, onDeleteAction }) => {
    const { t } = useTranslation()

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            PaperProps={{ sx: { minWidth: 200 } }}
        >
            <List sx={{ width: '100%' }}>
                <ListItemButton onClick={() => onDeleteAction(id!)}>
                    <ListItemIcon>
                        <Delete color="error" />
                    </ListItemIcon>
                    <ListItemText primary={t('dashboard.projectActionDelete')} />
                </ListItemButton>
            </List>
        </Popover>
    )
}
